import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D5BD8",
			d: "M6.167 6.778A3.059 3.059 0 0 1 3.11 3.722 3.059 3.059 0 0 1 6.167.667a3.059 3.059 0 0 1 3.055 3.055 3.059 3.059 0 0 1-3.055 3.056ZM3.57 8a2.905 2.905 0 0 0-2.903 2.903v3.972c0 .25.207.459.458.459h5.653v-3.82c0-1.149.855-2.096 1.961-2.261a2.35 2.35 0 0 1 .844-1.137C8.972 7.942 8.939 8 3.569 8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D5BD8",
			d: "M14.264 10.444H13.5v-.458c0-.59-.48-1.07-1.07-1.07h-1.527c-.59 0-1.07.48-1.07 1.07v.458H9.07c-.3 0-.571.126-.765.326l3.363 1.755 3.363-1.755a1.063 1.063 0 0 0-.766-.325Zm-3.514 0v-.458c0-.084.068-.153.153-.153h1.527c.085 0 .153.069.153.153v.458H10.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4D5BD8",
			d: "M11.879 13.448a.459.459 0 0 1-.424 0L8 11.645v2.619c0 .59.48 1.07 1.07 1.07h5.194c.59 0 1.07-.48 1.07-1.07v-2.619l-3.455 1.803Z"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonmin);
export { ForwardRef as ReactComponent };
